<template>
  <div class="app-content">
    <div class="title"></div>
    <div class="search-bar">
      <van-dropdown-menu>
        <van-dropdown-item v-model="type"
                           :options="option1"
                           @change="onDropdownChange" />
      </van-dropdown-menu>
    </div>
    <div class="container">
      <van-empty description="您没有相关的订单"
                 v-if="ordersItems?.length == 0" />
      <div class="content">
        <div class="order_container"
             v-for="(order, index) in ordersItems"
             :key="index">
          <div class="order_block">
            <div class="perItem">
              <div class="inline"
                   @click="findDetail(index, order?.id,order)">
                <div class="communionIcon">
                  <img class="icon_type"
                       v-if="order.type == 0"
                       src="../assets/jinqifahui.png" />
                  <img src="../assets/jingshengongde.png"
                       class="icon_type"
                       v-else-if="order.type == 1" />
                  <img src="../assets/huodongbaoming.png"
                       class="icon_type"
                       v-else-if="order.type == 2" />

                </div>
                <div class="light"
                     v-if="order.type == 0">近期法会</div>
                <div class="light"
                     v-else-if="order.type == 1">敬神功德</div>
                <div class="light"
                     v-else-if="order.type == 2">近期活动</div>
                <div class="light-end"
                     v-if="order.status == 0"
                     style="color: #000">
                  待支付
                </div>
                <div class="light-end"
                     v-else-if="order.status == 1"
                     style="color: #444">
                  已完成
                </div>
                <div class="light-end"
                     v-else-if="order.status == 2"
                     style="color: #444">
                  已取消
                </div>
              </div>
              <div class="inline">
                <div class="bookName">{{ order?.activityName }}</div>
                <div style="display: flex;flex:1;justify-content: flex-end;">
                  <div class="orderPrice"
                       v-if="order.status == 0"
                       style="color: #e65c2e">
                    ¥{{ order?.price }}
                  </div>
                  <div class="orderPrice"
                       v-else>¥{{ order?.price }}</div>
                </div>
              </div>
              <div class="inline_1">
                <div class="bookTime grey">{{ order.timeRange }}</div>
              </div>
              <div class="button_container">
                <van-button type="info"
                            size="small"
                            class="btn_pay"
                            v-if="order.status == 0"
                            @click="wxPayOrder(order?.id)">立即支付</van-button>
                <van-button class="button"
                            type="default"
                            size="small"
                            @click="findDetail(index, order?.id,order)">查看详情</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quanbudingdan",
  computed: {
    getType() {
      return this.$route.params.type;
    },
  },
  data() {
    return {
      ordersItems: [
        {
          activityType: "0",
          status: 0,
          activityName: "十一月初一消灾祈福仪式",
          price: 100,
          timeRange: "2024-12-01 08:30 至 2024-12-01 15:00",
        },
      ],
      type: null,
      option1: [
        { text: "全部订单", value: null },
        { text: "近期法会", value: 0 },
        { text: "敬神功德", value: 1 },
        { text: "活动报名", value: 2 },
      ],
    };
  },
  methods: {
    onDropdownChange(value) {
      console.log("选中的值:", value);
      // 在这里处理选项变化的逻辑
      this.type = value;
      this.$http.get("/tempt/api/sjte/getQmOrders", {
        params: {
          type: localStorage.getItem("zf_type"),
          // type: 0,
          activityType: value,
        },
      })
        .then((value) => {
          this.ordersItems = value.result;
        });
    },
    findDetail(index, orderId, order) {
      // this.$router.push("/QuanBuDingDanDetail",index);
      localStorage.setItem("zf_orderId", orderId);
      localStorage.setItem("zf_orderItem", JSON.stringify(order));
      this.$router.push({
        name: "QuanBuDingDanDetail",
        params: {
          id: index,
          type: this.$route.params.type,
          activityType: this.type,
        },
      });
      localStorage.setItem("zf_activity_type", this.type);
      localStorage.setItem("zf_id", index);
    },
    onBridgeReady(wxData) {
      console.log("wxData", wxData);
      const { appId, timeStamp, nonceStr, packageInfo, signType, paySign } =
        wxData;
      console.log(
        "wxData",
        appId,
        timeStamp,
        nonceStr,
        packageInfo,
        signType,
        paySign
      );
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId,
          timeStamp: timeStamp,
          nonceStr: nonceStr,
          package: packageInfo,
          signType: signType,
          paySign: paySign,
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            queryOrder();
            setLoading(false);
          }
        }
      );
    },
    /**
     * 支付
     * @param {*} type
     */
    async wxPayOrder(orderId) {
      try {
        const data = await this.$http.get("/tempt/api/sjte/payOrder", {
          params: {
            orderId: orderId,
          },
        });
        console.log(JSON.stringify(data));
        if (data.success) {
          this.onBridgeReady(data.result);
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
            }
          } else {
            this.onBridgeReady(data.result);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    // this.$http
    //   .get("/tempt/api/sjte/getQmOrders", {
    //     params: {
    //       type: localStorage.getItem("zf_type"),
    //       // type: 0,
    //       activityType: this.type,
    //     },
    //   })
    //   .then((value) => {
    //     this.ordersItems = value.result;
    //   });
  },
  mounted() {
    this.$http
      .get("/tempt/api/sjte/getQmOrders", {
        params: {
          type: localStorage.getItem("zf_type"),
          // type: 0,
          activityType: this.type,
        },
      })
      .then((value) => {
        this.ordersItems = value.result;
      });
  },
};
</script>

<style  scoped>
.app-content {
  height: 928px;
}
.container {
  background: rgb(170, 170, 170);
}
.van-empty {
  background: #fff;
}
.search-bar {
  left: 0;
  top: 0;
  -webkit-box-orient: horizontal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: #fff;
  z-index: 400;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #007aaa;
  font-weight: 400;
}
.van-dropdown-menu {
  -webkit-user-select: none;
  user-select: none;
  width: 500px;
}
.order_block {
  border-radius: 8px;
  background: #fff;
}
.perItem {
  padding: 12px 16px;
}

.inline {
  margin-top: 10px;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -webkit-box-pack: justify;
  align-items: center;
}
.light {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: 400;
}
.light-end {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  font-weight: 400;
  flex: 1;
  justify-content: flex-end;
}
.grey {
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 600;
  text-align: right;
}
.inline_1 {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  margin: 8px 8px 0 0;
  line-height: 20px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.bookName {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  letter-spacing: 0;
  font-weight: 700;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 66%;
  color: rgba(0, 0, 0, 0.4);
}
.orderPrice {
  font-family: HelveticaNeue-Bold;
  font-size: 20px;
  letter-spacing: 0;
  font-weight: 700;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.4);
}
.bookTime {
}
.order_container {
  padding: 12px 16px;
}
.button_container {
  margin-top: 8px;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  display: flex;
}
.search-bar {
  display: flex;
  align-items: center;
}
.order-type-fold {
  margin-left: auto; /* 图标居右 */
}
.button {
  background: #fff;
  border-radius: 22px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  margin-left: 8px;
  width: 70px;
  height: 23px;
  line-height: 23px;
}
.btn_pay {
  color: #007aaa;
  border-radius: 22px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  margin-left: 8px;
  width: 70px;
  height: 23px;
  line-height: 23px;
  background: #fff;
}
.communionIcon {
  width: 24px;
  height: 24px;
  margin: -3px 8px 0 0;
  background-size: cover;
}
.icon_type {
  background-size: cover;
  width: 24px;
  height: 24px;
}
</style>
